<template>
  <div class="nomore">没有更多了~</div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: '没有更多了~'
    }
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.nomore {
  font-size: 14px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #b8b8b8;
      text-align: center;
}
</style>
